export default {
  VBtn: {
    color: 'primary',
  },
  VCard: {
    variant: 'text',
  },
  VDataTableServer: {
    class: 'bg-transparent',
  },
  VSheet: {
    class: 'bg-transparent',
  },
  VTextField: {
    variant: 'outlined',
    hideDetails: 'auto',
  },
  VTextarea: {
    variant: 'outlined',
    hideDetails: 'auto',
  },
  VSelect: {
    variant: 'outlined',
    hideDetails: 'auto',
  },
  VAutocomplete: {
    variant: 'outlined',
    hideDetails: 'auto',
  },
  VCombobox: {
    variant: 'outlined',
    hideDetails: 'auto',
  },
}
